import { Grid } from '@mui/material';

export const Marketing = () => {
  return (
    <Grid
      container
      rowSpacing={0}
      columnSpacing={{ xs: 0, sm: 0, md: 0 }}
    ></Grid>
  );
};
